var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 25.6667C20.4432 25.6667 25.6666 20.4433 25.6666 14C25.6666 7.55667 20.4432 2.33333 13.9999 2.33333C7.5566 2.33333 2.33325 7.55667 2.33325 14C2.33325 20.4433 7.5566 25.6667 13.9999 25.6667Z",
    fill: "#22E0BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3434 18.1767C12.1101 18.1767 11.8884 18.0833 11.7251 17.92L8.42343 14.6183C8.08509 14.28 8.08509 13.72 8.42343 13.3817C8.76176 13.0433 9.32176 13.0433 9.66009 13.3817L12.3434 16.065L18.3401 10.0683C18.6784 9.73001 19.2384 9.73001 19.5768 10.0683C19.9151 10.4067 19.9151 10.9667 19.5768 11.305L12.9618 17.92C12.7984 18.0833 12.5768 18.1767 12.3434 18.1767Z",
    fill: "#060A33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.eccd93d1fc5248744b891bcd32507d67.svg";
export { ForwardRef as ReactComponent };